const createEnvironmentFlags = (
  development = false,
  staging = false,
  production = false
) => ({ development, staging, production });

const flags = {
  modularizedRegistryTile: createEnvironmentFlags(true, true, true),
  cartViewedEvent: createEnvironmentFlags(true, true, true),
  fastFacets: createEnvironmentFlags(true, true, false),
  seatingChartView2: createEnvironmentFlags(false, false, false), // - this is on hold
  invitesPLPDraperJames: createEnvironmentFlags(false, false, false), // these need to be flipped at the same time
  invitesPLPLovelyBride: createEnvironmentFlags(false, false, false), // these need to be flipped at the same time
  websitesPDPCarousel: createEnvironmentFlags(true, true, true),
  customizeUndoOnDelete: createEnvironmentFlags(true, true, true),
  customizeUndoOnAdd: createEnvironmentFlags(true, true, true),
  showCollaboratorLink: createEnvironmentFlags(true, true, true),
  PLPImgBigger: createEnvironmentFlags(true, true, true),
  persistentCart: createEnvironmentFlags(true, true, true),
  invitesPlacementCards: createEnvironmentFlags(false, false, false), // INVITES-1172
  stdSizeSegments: createEnvironmentFlags(true, true, true), // INVITES-1228
  fontRenderFix: createEnvironmentFlags(true, true, false), // INVITES-1054
  digitalPreviewPage: createEnvironmentFlags(true, true, true), // INV-308
  pdpModalModule: createEnvironmentFlags(true, true, true),
  publicWebNavCartModal: createEnvironmentFlags(true, true, true),
  checkForExistingDraftsOnPDP: createEnvironmentFlags(true, true, false),
  newPlpCardTile: createEnvironmentFlags(false, false, false), // INV-501
  collectAddressV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1726
  useSharedContentEditor: createEnvironmentFlags(false, false, false), // INV-499
  useElementAttributesTYC: createEnvironmentFlags(true, true, true), // INV-722
  uploadCsvModalV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1738
  holidayNav: createEnvironmentFlags(false, false, false), // MAS-777 , go live 11/11
  registryImportAccountPage: createEnvironmentFlags(true, true, true), // WEDDINGS-1501
  checkGeosuggest: createEnvironmentFlags(true, true, true), // WEDDINGS-1501
  isPrefillEventName: createEnvironmentFlags(true, true, false), // WEDDINGS-1781
  singleSampleAllCardTypes: createEnvironmentFlags(true, true, true), // INV-785
  singleSampleNoFoil: createEnvironmentFlags(true, true, true), // INV-784
  isEditPageHeaderV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1459
  confirmExitModalFlag: createEnvironmentFlags(true, true, false), // WEDDINGS-1785
  PLPHeroes: createEnvironmentFlags(true, true, true), // INV-917z
  invitesMagnetSilhouettePrice: createEnvironmentFlags(true, true, true), // INV-1013
  invitesCardCorrectionReviewBanner: createEnvironmentFlags(true, true, true), // INV-1085
  invitesTipModalsWithLinks: createEnvironmentFlags(true, true, true), // INV-1141 & INV-1145
  invitesReviewTipsAllModals: createEnvironmentFlags(true, true, true), // INV-1231
  invitesComparisonModuleMvp: createEnvironmentFlags(true, true, true), // INV-1107
  invitesShotkeyOrderByCardType: createEnvironmentFlags(true, true, true), // INV-1202
  invitesOrderMoreEnvReviewRedirect: createEnvironmentFlags(true, true, true), // INV-1117
  invitesRelatedSameCardType: createEnvironmentFlags(true, true, true), // INV-1209
  invitesLetterpressFilter: createEnvironmentFlags(true, true, false), // INV 1154
  invitesLetterpressMvp: createEnvironmentFlags(true, true, false), // INV-1009
  invitesDynamicReviewMinimumQuantity: createEnvironmentFlags(true, true, false),
  websiteRegistryRedisgn: createEnvironmentFlags(true, true, true), // WEDDINGS-1509
  weddingLandingRedesign: createEnvironmentFlags(true, true, true), // PAR-6 and others
  websiteRSVPRedisgn: createEnvironmentFlags(true, true, true), // WEDDINGS-1840 -check this
  blockRSVPPublish: createEnvironmentFlags(true, true, true), // - check this
  flagEventFormModalV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1840
  guestlistLPv2: createEnvironmentFlags(true, true, true), // PAR-8
  useV3PlanningPage: createEnvironmentFlags(true, true, true), // PAR-7
  checklistLPv2: createEnvironmentFlags(true, true, true), // PAR-9
  updateWeddingsFlows: createEnvironmentFlags(false, false, false), // MAS-1026 ON HOLD
  flagGuestListMobileFix: createEnvironmentFlags(true, true, true), // WEDDINGS-1820
  isManageMobileCmsActionsV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1871
  isRsvpListItemV2: createEnvironmentFlags(true, true, true), // WEDDINGS-1864,
  isGuestListTrackingEvents: createEnvironmentFlags(true, true, true), // WEDDINGS-1888
  invitesCustomFoil: createEnvironmentFlags(true, true, true), // INV-880
  guestListActivationV2: createEnvironmentFlags(true, true, true),      // Part 1 - WEDDINGS-1909 -ready to clean
  mobileGuestListActivation: createEnvironmentFlags(true, true, true), // Part 2 - WEDDINGS-1909 -ready to clean
  newSeatingPDF: createEnvironmentFlags(true, true, true), // WED-1905 - live on 3/13
  addBannerAdToPLP: createEnvironmentFlags(true, true, true), // INV-1139
  addBottomBannerToPDP: createEnvironmentFlags(true, true, true), // INV-1140
  isSpreadsheetUploadTracking: createEnvironmentFlags(true, true, true), // WEDDINGS-1910
  isRequestMissingInfoModal: createEnvironmentFlags(true, true, true), // WEDDINGS-1870
  isTrackWebsiteZolaRegistry: createEnvironmentFlags(true, true, true), // WEDDINGS-1920
  invitesGuestFontOverrides: createEnvironmentFlags(true, true, true), // INV-1066
  enclosuresInInvitesFlow: createEnvironmentFlags(true, true, false), // INV-1108
  usePreCheckoutSuggestionsModal: createEnvironmentFlags(true, true, true), // INV-1149
  isTrackWebsiteOtherRegistries: createEnvironmentFlags(true, true, true), // WEDDINGS-1934
  seatingChartLanding: createEnvironmentFlags(true, true, false), // WED-1927
  paperPLPPagination: createEnvironmentFlags(true, true, true), // MAS-1157
  hotelPlanner: createEnvironmentFlags(true, true, true), // WED-1939 - live on 3/15
  hotelPlannerBanner: createEnvironmentFlags(true, true, false), // WED-1939 part 2
  weddingShopModalAb: createEnvironmentFlags(true, true, true), // INV-1210
  isWebsiteEditPagesV2: createEnvironmentFlags(true, true, false), // WEDDINGS-1897
  changeTheDateCardType: createEnvironmentFlags(true, true, true), // INV-1259
  scheduledPaperPromo: createEnvironmentFlags(true, true, true), // MAS-1218
  websitePSA: createEnvironmentFlags(true, true, true), // WED-1955 - live on 3/25
  enableMostWantedTest: createEnvironmentFlags(true, true, false), // REGISTRY-4238
  isCmsPageFormV2: createEnvironmentFlags(true, true, false), // WEDDINGS-1898
};


const getEnvironment = () => {
  const zolaEnv = window.zola && window.zola.env;
  switch (zolaEnv) {
    case 'development':
    case 'dev':
      return 'development';
    case 'staging':
    case 'stage':
      return 'staging';
    case 'production':
    case 'prod':
      return 'production';
    default:
      return 'production';
  }
};

const get = flag => {
  if (flags[flag]) {
    return Boolean(flags[flag][getEnvironment()]);
  }
  return false;
};

export default {
  get,
  getEnvironment
};



// WEBPACK FOOTER //
// ./src/util/featureFlags.js